import React from "react";
import DataTable from "../DataTable/DataTable";
import ServicesStatusBoardHeader from "./ServicesStatusBoardHeader";
import ServicesStatusBoardActions from "./actions/ServicesStatusBoardActions";
import ServicesStatusBoardStore from "./stores/ServicesStatusBoardStore";


class ServicesStatusBoard extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.getStateFromStores();
        this._onChange = this._onChange.bind(this);
    }

    componentDidMount() {
        ServicesStatusBoardStore.addChangeListener(this._onChange);
        ServicesStatusBoardActions.init(this.props);
    }

    getStateFromStores() {
        return {
            currentDate: ServicesStatusBoardStore.getCurrentDate(),
            dataTableEndpoint: ServicesStatusBoardStore.getDataTableEndpoint(),
            dateFormat: ServicesStatusBoardStore.getDateFormat(),
            loading: ServicesStatusBoardStore.getLoading(),
            readOnly: ServicesStatusBoardStore.getReadOnly(),
            reservationSegments: ServicesStatusBoardStore.getReservationSegments(),
            requestServicesPath: ServicesStatusBoardStore.getRequestServicesPath(),
            timeFormat: ServicesStatusBoardStore.getTimeFormat(),
        };
    }

    render() {
        return (
            <div className='services-status-board'>
                <ServicesStatusBoardHeader {...this.state} date_format={this.props.dateFormat}/>

                <DataTable
                    ref="dataTable"
                    endpoint={this.state.dataTableEndpoint}
                    no_data_text={I18n.t('none')}
                    currency_unit={I18n.t('number.currency.format.unit')}
                    delimiter={I18n.t('number.currency.format.delimiter')}
                    separator={I18n.t('number.currency.format.separator')}
                    date_format={this.state.dateFormat}
                    time_format={this.state.timeFormat}
                />

                {this.state.loading ? <div className="loadingOverlay"><div className="spinner"></div></div> : null}
            </div>
        )
    };

    _onChange() {
        this.setState(this.getStateFromStores());
    }
}

export default ServicesStatusBoard